import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import store from './redux/store';
import './index.css';
import reportWebVitals from './reportWebVitals';
import MainRoutes from './routes';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from './pages/Login/authConfig';
import initializeIframeLanguage from './utils/iframeLanguageInit';

// Initialize language from iframelang parameter BEFORE React renders
// This ensures components get the correct language on initial mount
initializeIframeLanguage();

const root = ReactDOM.createRoot(document.getElementById('root'));

const msalInstance = new PublicClientApplication(msalConfig);
root.render(
    <Provider store={store}>
        {/* <React.StrictMode> */}
            <MsalProvider instance={msalInstance}>
                <MainRoutes />
            </MsalProvider>
        {/* </React.StrictMode> */}
    </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
